import * as React from "react"
import { Link } from 'gatsby-plugin-modal-routing-3'
import './styles/index.scss';

import Layout from "../layout/layout"
import Seo from "../layout/seo"
import FeaturedSpeakers from "../components/featuredSpeakers"
import imgHeroLogo from "../images/img-hero-2022.svg"

const IndexPage = () => (
  <Layout innerPage={false}>
    <Seo title="Ignite Summit, 2024 — Call for Speakers is now open!" description="Ignite Summit is the premier event for developers who are interested in using Apache Ignite, distributed databases, and in-memory computing to tackle speed and scale challenges." />
      <section className="homeHeader" >
        <div className="bgWrapper">
          <div className="container " >
            <div className="top" >
              <div className="top__header">
                <img src={imgHeroLogo} width={`306px`} height={`73px`} />
                <div className="description">
                  <div className="description__date">june 11</div>
                  <div className="description__info highlight">virtual event</div>
                </div>
              </div>
              <div className="content">
                <h1>The Call for Speakers is <strong>open until May 1st</strong></h1>
                <p className="highlight">We are seeking technical content from in-memory computing practitioners: deployment stories, technical deep dives, best practices, and integrations.</p>
                <p>Submit your proposal to share your Ignite experience with the global Ignite community!</p>
                <div className="buttons">
                  <Link
                    to="https://sessionize.com/ignite-summit-2024/"
                    className="more button"
                  >
                    become a speaker
                  </Link>
                  <Link
                    to="https://events.ringcentral.com/events/ignite-summit-2024-june-11"
                    className="button active"
                  >
                    reserve your seat
                  </Link>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  
  </Layout>
)

export default IndexPage
